export const STANDARD_LABELS = {
  qms: 'QMS',
  ems: 'EMS',
  ohsms: 'OHSMS',
  cms: 'CMS',
  cgmp: 'CMS'
}

export function normalizeStandard(value) {
  const text = String(value || '').trim().toLowerCase()
  if (['qms', 'qm', 'iso9001', '9001'].includes(text)) return 'qms'
  if (['ems', 'em', 'iso14001', '14001'].includes(text)) return 'ems'
  if (['ohsms', 'ohs', 'om', 'iso45001', '45001'].includes(text)) return 'ohsms'
  if (['cms', 'cgmp', 'cm', 'iso22716', '22716'].includes(text)) return 'cms'
  return text
}

// 신청서 체크박스와 customer.certification_standard 는 ISO 22716 을 'cgmp' 로 쓴다.
// normalizeStandard 의 'cms' 를 그대로 넣으면 체크박스가 빈 채로 보이고, 다시 누르면
// 'cms'·'cgmp' 가 같이 저장된다.
export function toApplicationStandard(value) {
  const standard = normalizeStandard(value)
  return standard === 'cms' ? 'cgmp' : standard
}

export function standardLabel(standard) {
  return STANDARD_LABELS[normalizeStandard(standard)] || String(standard || '').toUpperCase()
}

export function standardFromCertNo(certNo) {
  const text = String(certNo || '').toUpperCase()
  if (text.includes('KAIQM') || text.includes('KAI-Q-')) return 'qms'
  if (text.includes('KAIEM') || text.includes('KAI-E-')) return 'ems'
  if (text.includes('KAIOM') || text.includes('KAIOH') || text.includes('KAI-O-')) return 'ohsms'
  if (text.includes('KAICM') || text.includes('KAI-C-')) return 'cms'
  return ''
}

export function certNoMatchesStandard(certNo, standard) {
  return standardFromCertNo(certNo) === normalizeStandard(standard)
}

export function auditDisplay(type, degree) {
  if (!type) return '-'
  if (type === '사후' && degree && degree !== 'null') return `${type} ${degree}`
  if (degree && degree !== 'null' && degree !== '') return `${type} ${degree}`
  return type
}

export function normalizeDetailRows(details) {
  if (!Array.isArray(details)) return []
  return details
    .map((row) => {
      const certNo = row.cert_no || row.certNo || ''
      const standard = normalizeStandard(row.standard || row.std || standardFromCertNo(certNo))
      const auditType = row.audit_type || row.auditType || ''
      const auditDegree = row.audit_degree || row.auditDegree || ''
      if (!standard || !auditType) return null
      return {
        standard,
        cert_no: certNo || null,
        audit_type: auditType,
        audit_degree: auditDegree || null,
        previous_audit_no: row.previous_audit_no || row.previousAuditNo || null,
        previous_audit_type: row.previous_audit_type || row.previousAuditType || null,
        previous_audit_degree: row.previous_audit_degree || row.previousAuditDegree || null,
        cert_issued_date: row.cert_issued_date || row.certIssuedDate || null,
        cert_due_date: row.cert_due_date || row.certDueDate || null,
        source: row.source || 'ui'
      }
    })
    .filter(Boolean)
}

export function isMixedDegree(degree) {
  return String(degree || '').trim() === '혼합'
}

export function hasMixedSurveillanceCycles(details) {
  const cycles = new Set(
    normalizeDetailRows(details)
      .filter((row) => row.audit_type === '사후')
      .map((row) => row.audit_degree)
      .filter(Boolean)
  )
  return cycles.size > 1
}

export function detailLine(row) {
  return `${standardLabel(row.standard)}${row.cert_no ? ` / ${row.cert_no}` : ''}: ${auditDisplay(row.audit_type, row.audit_degree)}`
}

export function detailSummary(details) {
  const rows = normalizeDetailRows(details)
  return rows.map(detailLine).join('\n')
}
